import { INVOICELIST } from "../constants/ActionTypes";

const initialState = {
  INVOICELIST_DATASOURCE:[]
};

export default function ( state = initialState, action = {} ){
  switch( action.type ){
    case INVOICELIST.INVOICELIST_DATASOURCE:
      return Object.assign({}, state, {
        INVOICELIST_DATASOURCE: action.INVOICELIST_DATASOURCE
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./common/reducers/invoiceList.js